/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Validemail1Inputs */

const en_settings_collaborators_validemail1 = /** @type {(inputs: Settings_Collaborators_Validemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address" |
*
* @param {Settings_Collaborators_Validemail1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_validemail1 = /** @type {((inputs?: Settings_Collaborators_Validemail1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Validemail1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_validemail1(inputs)
});
export { settings_collaborators_validemail1 as "settings_collaborators_validEmail" }